module.exports = __webpack_public_path__ + "img/cyan_semicircle_sleepy_eyes.8470ca7f.png";